<template>
  <div class="routeContainer">
    <div v-for="vak in vakken" :key="vak">
      <router-link :to="`/stomerij/${vak.toLowerCase().replace(' ', '_')}`">
        <ExploreComponent :vak="vak"/>
      </router-link>
    </div>
  </div>
</template>

<script>
import ExploreComponent from "@/components/ExploreComponent";

export default {
  name: "Stomerij",
  components: {
    ExploreComponent
  },
  data() {
    let vakken = [
      ...new Set(this.$parent.DBItemsStomerij.map(el => el.section))
    ];
    vakken = vakken.map(vak => vak === '' ? 'andere' : vak)
    return {
      vakken: vakken
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  }
};
</script>

<style scoped></style>
